import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import styled from 'styled-components';
import GenerateTest from "./TestForm.js";
import config from "../config";

const Container = styled.div`
  padding: 5px 20px;
`;

const Heading = styled.h3`
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

const SubHeading = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #d1d5db;
`;

const TableCell = styled.td`
  border: 1px solid #d1d5db;
  padding: 0.5rem;
`;

const TableHeader = styled.th`
  border: 1px solid #d1d5db;
  padding: 0.5rem;
`;

const Test = () => {
  const [categories, setCategories] = useState([]);
  const [previousState, setPreviousState] = useState(null);
  const [questionsData, setQuestionsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    async function fetchCategories() {
      try {
        const response = await fetch(`${config.API_BASE_URL}/testing`);
        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }
        const data = await response.json();
        setCategories(data);
        setPreviousState(data);
      } catch (err) {
        setLoadingError(err.message);
      } finally {
        setLoading(false);
      }
    }

    async function fetchQuestions(id) {
      try {
        const response = await fetch(`${config.API_BASE_URL}/testing/${id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }
        const data = await response.json();
        setQuestionsData(data);
      } catch (err) {
        setLoadingError(err.message);
      } finally {
        setLoading(false);
      }
    }

    if(id) {
      fetchQuestions(id);
    } else {
      fetchCategories();
    }
  }, [id]);

  const handleBack = () => {
    //setQuestionsData(null);
    // TODO use powrót below <div align="center"><a href="#" onClick={handleBack}>powrót</a></div><br/>
    if (previousState) {
      setCategories(previousState.data);
      setPreviousState(null);
    }
  };

  if (id && questionsData) {
    return (
      <>
      <GenerateTest
        testTitle={questionsData.categoryName}
        questions={questionsData.questions}
      />
      </>
    );
  } else {
    return (
      <Container>
        <h5>Lista testów</h5>
        {loading ? (
          <p><b>Dane są ładowane ...</b></p>
        ) : loadingError ? (
          <p><b>Przepraszamy, wystąpił problem przy wczytywaniu</b></p>
        ) : (
          <>
          <SubHeading>Wybór odpowiedzi pasującej do zdania</SubHeading>
          <div>Tradycyjny test, w którym podane jest zdanie z brakującym fragmentem. Z możliwych odpowiedzi należy wybrać jedną, pasującą do zdania.</div>
          <br/>
          {categories.length > 0 && (
            <Table>
              <thead>
                <tr>
                  <TableHeader>Kategoria</TableHeader>
                  <TableHeader>Liczba pytań</TableHeader>
                  <TableHeader>Akcja</TableHeader>
                </tr>
              </thead>
              <tbody>
                {categories.map((category) => (
                  <tr key={category.category_id}>
                    <TableCell><b>{category.category_name}</b></TableCell>
                    <TableCell><b>{category.question_count}</b> pytań w bazie</TableCell>
                    <TableCell><Link to={`/test/${category.category_id}`}>10 losowych pytań</Link></TableCell>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}

          <SubHeading>Synonimy</SubHeading>
          <div>Jest to test polegający na wskazaniu odpowiedzi, które jest synonimem podanego słowa. Test jest zbudowany w oparciu o darmową bazę danych synonimów 
          <Link to="http://openthes-es.berlios.de/" target="_blank" rel="noopener noreferrer">OpenThesaurus-es - Tesauro en español</Link> i jest losowy. Samych możliwych pytań jest 4825!
          </div>
          <Link to="/test/s">Losowy test synonimów (10 pytań)</Link>
          </>
        )}
      </Container>
    );
  }
};

export default Test;